import { Children, useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import {
  DeleteForeverIcon,
  FolderCopyIcon,
  FolderOffIcon,
  CheckIcon,
  CloseIcon,
  EditIcon,
} from "src/Pages/components/Icons/Icons";

import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";

import { useHttpTableAdministradora } from "./Hooks/useHttpTableAdministradora";
import { THeadAdministradora } from "./THead";
import { ModalAdministradora } from "../Form";
import { ModalChangeIsActiveAdministradora } from "../ChangeIsActiveAdministradora/ModalChangeIsActiveAdministradora";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";

export const TableAdministradora = () => {
  const { listAdministradora, setValuesInputsAdministradora } =
    useContextComissoes();

  const { attTable, setId } = useConfigPageContext();
  const { handleGet } = useHttpTableAdministradora();

  const [openModalAdministradora, setOpenModalAdministradora] = useState(false);
  const [openModalActiveAdministradora, setOpenModalActiveAdministradora] =
    useState(false);
  const [valueActiveAdministradora, setValueActiveAdministradora] =
    useState<boolean>(true);

  const handleGetIdToEdit = (id: string, administradora: string) => {
    setId(id);
    setOpenModalAdministradora(true);
    setValuesInputsAdministradora({ name: administradora, isActive: true });
  };

  useEffect(() => {
    handleGet();
  }, [attTable]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/administrators" });

  return (
    <TableCore
      isNotPagination
      title="Administradoras"
      heightTable="420px"
      Modals={
        <>
          <ModalAdministradora
            openModal={openModalAdministradora}
            setOpenModal={setOpenModalAdministradora}
          />
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
          <ModalChangeIsActiveAdministradora
            isActiveOperadora={valueActiveAdministradora}
            modalIsActiveOperadora={openModalActiveAdministradora}
            setModalIsActiveOperadora={setOpenModalActiveAdministradora}
          />
        </>
      }
      THead={<THeadAdministradora />}
      qtdList={listAdministradora.length}
      cardAdd={{
        title: "Administradoras",
        buttons: [
          <ButtonCore
            size="small"
            startIcon={<AddIcon />}
            title="Criar"
            onClick={() => setOpenModalAdministradora(true)}
          />,
        ],
      }}
    >
      {Children.toArray(
        listAdministradora.map((item) => {
          return (
            <TableRowCore id={String(item.code)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        onClick: () =>
                          handleGetIdToEdit(String(item.code), item.name),
                      },
                      {
                        icon: item.isActive ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                        isDisabled: true,
                        background: "warning",
                        title: item.isActive ? "Desativar" : "Ativar",
                        onClick: () => {
                          setId(item.name);
                          setOpenModalActiveAdministradora(true);
                          setValueActiveAdministradora(!item.isActive);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore values={item.name} />

              <TdCore
                textAlign="center"
                values={
                  item.isActive ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
